import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { LabelContainerModel } from '../../../../../../models/aggregates/erp/label';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { LabelCriteriaModelQuery, LabelQueryCriteriaClass } from '../../../criteria';
import { Observable } from 'rxjs';
import { Pagination } from '../../shared/pagination.model';

@Injectable({
    providedIn: 'root'
})
export class LazadaReadyToShipService extends BaseApiTemplateService<any> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'lazada/ready-to-ship';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = this.url;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'lazada/ready-to-ship';
        this.httpClient = http;
    }

    postWithParam(pagination: Pagination, visa: ApiVisa) {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
        }
        const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
        return this.httpClient.post<PagingResponseModel<any>>(UrlByCriteria, pagination.getQueryKeyValues, this.getHttpHeader(visa));    
    }
}
